goog.provide('el8.shared.util.billing');

/**
 * Utility functions for interpreting and presenting IMO terms and ICD-10 codes
 */
el8.shared.util.billing = (function (){
    var that = {};

    /**
     * Helper to determine if an ICD-10 code is explicitly known to be invalid for billing,
     * given time of service and optional effective period (start/end dates).
     *
     * @param {string | null} startDate Date (YYYY-MM-DD) code became valid, if null, unknown
     * @param {string | null} endDate Date (YYYY-MM-DD) code became invalid, if null, unknown
     * @param {number} timeOfServiceMs Date/time of service (in milliseconds since epoch)
     * @returns {boolean} True iff code is explicitly invalid for billing
     */
    that.isCodeNonBillable = function(startDate, endDate, timeOfServiceMs) {
        if (!timeOfServiceMs) return false;

        // Code is non-billable before the known effective start date
        if (startDate) {
          var startTime = new Date(startDate).getTime();
          if (timeOfServiceMs < startTime) return true;
        }

        // Code is non-billable on or after the known effective end date
        if (endDate) {
          var endTime = new Date(endDate).getTime();
          return (timeOfServiceMs >= endTime);
        } 

        return false;
    }

    return that;
})();
